var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "wrapper",
    staticClass: "wrapper",
    class: {
      wrapper_active: _vm.active
    },
    style: {
      width: ("" + (_vm.width))
    }
  }, [_c('div', {
    staticClass: "wrapper__child-wrapper",
    style: {
      'padding-bottom': ((_vm.ratio * 100) + "%")
    }
  }, [_c('div', {
    ref: "child",
    staticClass: "wrapper__child",
    style: {
      transform: ("scale(" + (_vm.scale) + ")"),
      width: ("" + (_vm.childWidth))
    }
  }, [_vm._t("default")], 2)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }